<template>
  <div class="video-item-wrap" :class="{active: video.eventAttrId === videoDanmuSet.attrId}">
    <div class="video-item">
      <div class="video-count">
        <img src="@/assets/image/video_count.png" alt="" />
        <span>{{ video.lookTimes }}</span>
      </div>
      <img class="video-cover" :src="$isCdn(video.eventAttrSmallImgUrl)" alt="" />
      <div class="video-title van-ellipsis">{{ video.eventAttrName }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['video'],
  computed: {
    videoDanmuSet() {
      return this.$store.state.activePlay.videoDanmuSet
    }
  }
}
</script>

<style scoped lang="scss">
.video-item-wrap + .video-item-wrap {
  margin-left: 10px;
}
.video-item-wrap {
  border: 1px solid transparent;
  padding: 3px;
  display: inline-block;
  border-radius: 8px;
  &.active {
    border-color: #4465f3;
  }
}
.video-item {
  position: relative;
  width: 130px;
  height: 70px;
  border-radius: 8px;
  overflow: hidden;
}
.video-count {
  position: absolute;
  display: flex;
  align-items: center;
  right: 6px;
  top: 3px;
  color: #fff;
  span {
    font-size: 12px;
    margin-left: 4px;
  }
  img {
    width: 16px;
    height: 14px;
  }
}
.video-cover {
  width: 100%;
  height: 100%;
}
.video-title {
  font-size: 12px;
  height: 20px;
  line-height: 20px;
  padding: 0 8px;
  position: absolute;
  left: 0;
  width: 100%;
  bottom: 0;
  background: rgba(0, 5, 32, 0.32);
  color: #fff;
}
</style>
